import { AppState } from '../store/reducers';
import { S3Result } from '../modules/S3MediaDropzone/index';

export const URL_STAGING = 'staging';
export const URL_PRODCUTION = 'production';
export const URL_LOCAL = 'local';
export const URL_MEDIA = 'https://media.aboutyou.de/cms/';
export const URL_STAGING_BUCKET = 'https://ay-cms-staging-input-bucket.s3-eu-west-1.amazonaws.com/';

interface SiteParams {
  [key: string]: string;
}

export function getQueryParameter(
  name: string,
  url: string,
  defaultValue: any = void 0
): any {
  return new URLSearchParams(url).get(name);
}

// taken from https://gist.github.com/pirate/9298155edda679510723
function getUrlParams(search: string) {
  const hashes = search.slice(search.indexOf('?') + 1).split('&');
  return hashes.reduce((params, hash) => {
    let [key, val] = hash.split('=');
    return Object.assign(params, { [key]: decodeURIComponent(val) });
  }, {});
}

export function extendWithPath(
  url: string,
  path: string,
  keepQuery: boolean = true
) {
  const queryPosition = url.indexOf('?');

  if (queryPosition === -1) {
    return `${url}/${path}`;
  }

  return `${url.substring(0, queryPosition)}/${path}${
    keepQuery ? url.substring(queryPosition) : ''
  }`;
}

export function getUrlParamsFromState(state: AppState): SiteParams {
  const {
    routerReducer: {
      location: { pathname, search },
    },
  } = state;
  const params = getUrlParams(pathname + (search || ''));
  return params;
}

export function getUrlParamFromState(
  param: string,
  state: AppState,
  defaultValue?: string
): string | undefined {
  return getUrlParamsFromState(state)[param] || defaultValue;
}

export function getBaseUrl(mobile?: boolean): string {
  return mobile ? '//m.aboutyou.de' : '//www.aboutyou.de';
}

export function getEnvironmentFromUrl() {
  const hostname = window.location.hostname;
  if (hostname.indexOf('cms-staging.collins') > -1) {
    return URL_STAGING;
  } else if (hostname.indexOf('cms.collins') > -1) {
    return URL_PRODCUTION;
  } else {
    return URL_LOCAL;
  }
}

export function getAwsUrl() {
  return getEnvironmentFromUrl() === URL_PRODCUTION
    ? URL_MEDIA
    : URL_STAGING_BUCKET;
}

export function getVideoUrl(
  video: S3Result | string,
  useMediaUrl?: boolean
): string {
  const env = getEnvironmentFromUrl();
  if (typeof video !== 'string') {
    const { s3Path, filePath } = video;

    if (env === URL_PRODCUTION || useMediaUrl) {
      return URL_MEDIA + filePath;
    }

    return `${stripeS3Params(s3Path)}`;
  } else {
    return env === URL_PRODCUTION
      ? URL_MEDIA + video
      : URL_STAGING_BUCKET + video;
  }
}

export function stripeS3Params(s3Url: string): string {
  const idx = s3Url.indexOf('?');
  return idx > -1 ? s3Url.substr(0, idx) : s3Url;
}

export const addSearchQuery = (url: string, searchQuery?: string) => {
  if (searchQuery) {
    const idxSearch = url.indexOf('&filter[search]=');
    if (idxSearch === -1) {
      url += '&filter[search]=' + searchQuery;
    }
  }

  return url;
};

export const addPage = (url: string, page: number) => {
  const idxPage = url.indexOf('?page=');
  if (idxPage > -1) {
    url = url.substr(0, idxPage) + '?page=' + page;
  } else {
    url = url + '?page=' + page;
  }

  return url;
};



// WEBPACK FOOTER //
// ./src/utils/url.ts